module.exports = __webpack_public_path__ + "store/img/optInImage-ca.90950f5c.png";